"use client";
import type { ReactElement, ReactNode } from "react";
import { IconArrowsDiagonalMinimize2, IconArrowsMaximize, } from "@tabler/icons-react";
import { Cbutton } from "../Cbutton";
import { ButtonPreset } from "@/constants/componentPresets";
import { ICON_BTN_CONTAINER_STYLE, ICON_BTN_ICON_SIZE, ICON_BTN_RADIUS, ICON_BTN_SIZE, TOP_BAR_GROUP_STYLE, TOP_BAR_SEPARATOR_STYLE, } from "./CmarkdownvisualStyles";
interface CmarkdownvisualCanvasControlsProps {
    controls?: ReactNode;
    hasCompact: boolean;
    onCollapse: () => void;
    onOpenModal: () => void;
}
interface CollapseButtonInput {
    hasCompact: boolean;
    onCollapse: () => void;
}
function renderCollapseButton({ hasCompact, onCollapse, }: CollapseButtonInput): ReactElement | null {
    if (!hasCompact) {
        return null;
    }
    return (<Cbutton icon={IconArrowsDiagonalMinimize2} iconSize={ICON_BTN_ICON_SIZE} preset={ButtonPreset.Ghost} radius={ICON_BTN_RADIUS} padding={0} height={ICON_BTN_SIZE} containerStyle={ICON_BTN_CONTAINER_STYLE} onClick={onCollapse}/>);
}
export function CmarkdownvisualCanvasControls({ controls, hasCompact, onCollapse, onOpenModal, }: CmarkdownvisualCanvasControlsProps): ReactElement | null {
    const modalButton = (<Cbutton icon={IconArrowsMaximize} iconSize={ICON_BTN_ICON_SIZE} preset={ButtonPreset.Ghost} radius={ICON_BTN_RADIUS} padding={0} height={ICON_BTN_SIZE} containerStyle={ICON_BTN_CONTAINER_STYLE} onClick={onOpenModal}/>);
    const collapseButton = renderCollapseButton({ hasCompact, onCollapse });
    if (!controls && !collapseButton) {
        return null;
    }
    return (
      <div style={TOP_BAR_GROUP_STYLE}>
        {controls}
        {controls && (<span style={TOP_BAR_SEPARATOR_STYLE}/>)}
        {modalButton}
        {collapseButton}
      </div>
    );
}
